export class TypeTir {
  typeTirId: number;
  nom: string;
  siteId: number;
}
